import { parseError, useSubmitProps } from "core/shared";
import { action } from "framework/config/action";
import { URLS } from "framework/config/urls";

export function useSendMessage({ onSuccess, onError }: useSubmitProps) {
  const contactUsAction = action(URLS.contactUs);

  const sendMessage = async ({ values, form }) => {
    const response = await contactUsAction(values);

    form.submitting(false);

    if (response.isOK) {
      onSuccess?.(response.data);
      form.reset();
    } else {
      onError?.(parseError(response));
    }
  };

  return { sendMessage };
}
